export default [{
  path: '/store-apps',
  name: 'store-app',
  component: () => import('@/app/store-apps/Apps'),
  meta: { }
}]
